// matches the API's limit on submission ids per remarket run
export const MAX_REMARKET_SUBMISSIONS = 2000;

// The homeowners sales channels a remarket can be limited to (RemarketInfo.RemarketableSalesChannels in the API).
// Values are the API's SalesChannel names; the labels are the market names the portal shows elsewhere.
export const REMARKET_SALES_CHANNELS = [
    { value: 'Munich', label: 'Munich RE (Munich)' },
    { value: 'Digital', label: 'Amwins Access Alpha (Digital)' },
    { value: 'VavePersonalLines', label: 'Vave Personal Lines (VavePersonalLines)' },
    { value: 'Human', label: 'Underwriter referral (Human)' }
];

// A remarket that hasn't been voided: the agent hasn't edited and requoted it, so its remarket terms (e.g. a Digital quote that
// can be bound however far ahead its term begins) still apply. Once voided it's ordinary new business.
export const isActiveRemarket = (submission: any): boolean => !!submission?.RemarketInfo && !submission.RemarketInfo.VoidedAt;

// A remarket released to its agent that the agent hasn't edited and requoted yet; Edit & Requote voids it.
export const isReleasedActiveRemarket = (submission: any): boolean => isActiveRemarket(submission) && !!submission.RemarketInfo.ReleasedAt;

// A remarketed quote can't be refined: refining would keep the remarket's terms on coverage the remarket didn't quote. Edit &
// Requote changes it instead, as new business, after which it can be refined like any other quote.
export const canRefineQuotes = (submission: any): boolean => !isActiveRemarket(submission);
export const REMARKET_REFINE_MESSAGE = "Remarketed quotes can't be refined. To change the coverage, use Edit & Requote, which requotes it as new business. (Warning: edit & requote will void the current remarketed quote.)";

// non-prod submission ids have a dash after the prefix, e.g. SUB-1911810556
const SUBMISSION_ID_PATTERN = /^SUB-?\d+(\.\d+)?$/;

export interface ParsedSubmissionIds {
    valid: string[];
    invalid: string[];
}

// Admins paste ids from a spreadsheet column (one per line), a CSV, or a space separated list. Normalize them the same way
// the API does (trimmed, upper-cased, de-duplicated) so the count on screen is the number of jobs that will be queued.
export const parseSubmissionIds = (input: string | null | undefined): ParsedSubmissionIds => {
    const tokens = (input ?? '')
        .split(/[\s,;]+/)
        .map(token => token.trim().toUpperCase())
        .filter(token => token !== '');

    const unique = [...new Set(tokens)];

    return {
        valid: unique.filter(id => SUBMISSION_ID_PATTERN.test(id)),
        invalid: unique.filter(id => !SUBMISSION_ID_PATTERN.test(id))
    };
};
